<template>
  <div class="formxieyi" v-if="qrCode">
    <!-- 官方交流群二维码弹窗 -->
    <div class="pagePopMask pFull" @click.self="closePop"></div>
    <div class="pagePop pCenter">
      <div class="w">
        <div class="tit fnt_32 relative">官方交流群二维码</div>

        <div class="cont txtCont scrollable" ref="scrollDiv">
          <img :src="curInfoArray.qrImage">
        </div>

        <div class="btnBox fnt_18 btnBox2">
          <button class="btn btn1" title="确认" @click="agreeFun('1')">确认</button>
          <div class="btn btn2" :title="globalDataArray.siteTemplateLanguage.cancel" @click="agreeFun('2')">{{ globalDataArray.siteTemplateLanguage.cancel }}</div>
        </div>
        <div class="close" @click.self="closePop"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import { getArticleDetail, getIndexInfo } from '@/api/api'
export default {
  name: 'QRCode',
  props: {
    qrCode: {
      type: Boolean,
      default: false
    },
    curInfoArray: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      content: {}
    }
  },
  watch: {
    qrCode: {
      immediate: true,
      handler(val) {
        if (val) {
          console.log(val)
        }
      }
    }
  },
  computed: {

  },
  methods: {

    agreeFun(res) {
      // 自定义事件，把res传给父组件,发射事件
      this.$emit('update:qrCode', false)
    },

    closePop() {
      this.$emit('update:qrCode', false)
    }

  }
}
</script>
<style lang="scss" scoped>
::v-deep .pagePop .cont.txtCont {
  text-align: center;
  max-height: 36em;
}
</style>
